import { render, staticRenderFns } from "./modalBale.vue?vue&type=template&id=1ed055fc&scoped=true&"
var script = {}
import style0 from "./modalBale.vue?vue&type=style&index=0&id=1ed055fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed055fc",
  null
  
)

export default component.exports